import * as React from 'react';
import Popup, { IPopup } from './newPopup';
import styled from 'styled-components';
import { PopupTheme } from '../../enums/common';

const WrapperMessagePopup = styled.div(
  ({ theme }) => `
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding : 0 10px 0 10px;
      align-items: center;
`
);

const MessageTextPopup = styled.div(
  ({ theme }) => `
      font-size : 14px;
      font-weight: bold;
      color : black; /*theme trow an error for some reason*/
      padding : 10px 0 10px 0;
      min-width: 100px;
      text-align: center;
`
);

const SIconStatus = styled.div(({ theme, status }: { theme; status }) => {
  return `
          display: inline-block;
          width: 70px;
          height: 70px;
          margin : 10px 0 10px 0;
          background-size: contain;
          background-image: url(${theme.icons[status]});
          background-repeat: no-repeat;
  `;
});

export interface IMessageProps {
  title: string;
  description: string;
  status: PopupTheme;
}

interface IMessagePopupProps extends IPopup {
  messagePopupData: IMessageProps;
}

export const MessagePopup: React.FC<IMessagePopupProps> = (props: IMessagePopupProps) => {
  const { blueButtonAction, blueButtonText, boldText, dataAt, messagePopupData } = props;
  const { title = '', description = '', status = PopupTheme.danger } = messagePopupData;

  const getStatusIcon = (status: PopupTheme) => {
    switch (status) {
      case PopupTheme.danger:
        return 'error';
      case PopupTheme.success:
        return 'success';
      default:
        return 'close';
    }
  };

  return (
    <Popup blueButtonAction={blueButtonAction} blueButtonText={blueButtonText} boldText={boldText} dataAt={dataAt}>
      <WrapperMessagePopup>
        <MessageTextPopup>{title}</MessageTextPopup>
        <MessageTextPopup>{description}</MessageTextPopup>

        <SIconStatus status={getStatusIcon(status)} />
      </WrapperMessagePopup>
    </Popup>
  );
};
